// src/components/Dashboard.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <h1>📝 PDF Toolkit Dashboard</h1>
      <p>Select a tool to get started:</p>
      <div style={styles.buttonContainer}>
        <button onClick={() => navigate('/text-to-pdf')} style={styles.button}>
          Text to PDF
        </button>
        <button onClick={() => navigate('/merge-pdfs')} style={styles.button}>
          Merge PDFs
        </button>
        <button onClick={() => navigate('/image-to-pdf')} style={styles.button}>
          Image to PDF
        </button>
        <button onClick={() => navigate('/SplitPDF')} style={styles.button}>
          Split PDF
        </button>
        <button onClick={() => navigate('/compress-pdf')} style={styles.button}>
          Compress PDF
        </button>
        <button onClick={() => navigate('/watermarkPdf')} style={styles.button}>
          Watermark PDF
        </button>
        <button onClick={() => navigate('/pdf-cropper-fixed')} style={styles.button}>
          PDF Cropper (Fixed)
        </button>
        <button onClick={() => navigate('/add-page-numbers')} style={styles.button}>
          Add Page Numbers
        </button>
        <button onClick={() => navigate('/delete-pages')} style={styles.button}>
          Delete PDF Pages
        </button>
        <button onClick={() => navigate('/excel-to-pdf')} style={styles.button}>
          Excel to PDF
        </button>    
       
        <button onClick={() => navigate('/excelsheets-to-pdf')} style={styles.button}>
          Excel Sheets to PDF
        </button>
      
        {/* <button onClick={() => navigate('/edit-pdf')} style={styles.button}>
          Edit PDF
        </button> */}
        <button onClick={() => navigate('/pdf-editor')} style={styles.button}>
          PDF Editor
        </button>
        
      </div>
      <div className="content">
<div className="content">

  <h2>PDF Kit Dashboard Features</h2>

  <p>
    The PDF Kit Dashboard offers a complete suite of PDF tools designed for efficiency 
    and ease of use. Key features include:
  </p>

  <p>
    <strong>Merge PDF:</strong> Combine multiple PDF files into a single, organized document.
  </p>

  <p>
    <strong>Split PDF:</strong> Extract specific pages or divide large files into smaller, manageable PDFs.
  </p>

  <p>
    <strong>Compress PDF:</strong> Reduce file sizes while maintaining high readability and quality.
  </p>

  <p>
    <strong>PDF to Word:</strong> Convert PDFs into fully editable Word documents with formatting intact.
  </p>

  <p>
    <strong>Word to PDF:</strong> Transform Word documents into professional-quality PDF files.
  </p>

  <p>
    <strong>PDF to Image:</strong> Export pages as high-quality JPEG or PNG images.
  </p>

  <p>
    <strong>Image to PDF:</strong> Combine images into a clean, single PDF document.
  </p>

  <p>
    <strong>Rotate Pages:</strong> Rotate individual pages or entire documents as needed.
  </p>

  <p>
    <strong>Reorder Pages:</strong> Drag and drop pages to rearrange them effortlessly.
  </p>

  <p>
    <strong>Delete Pages:</strong> Remove unwanted pages with just one click.
  </p>

  <p>
    <strong>Add Watermark:</strong> Insert text or image watermarks for branding or document protection.
  </p>

  <p>
    <strong>Protect PDF:</strong> Add passwords and encryption to secure your documents.
  </p>

  <p>
    <strong>Unlock PDF:</strong> Remove password protection when permitted.
  </p>

  <p>
    <strong>Edit PDF:</strong> Modify text, images, highlights, and annotations directly within the PDF.
  </p>

  <p>
    <strong>Extract Text:</strong> Quickly pull text content from PDFs using smart recognition.
  </p>

  <h3>Why Choose the PDF Kit Dashboard?</h3>

  <p>
    <strong>All-in-One Platform:</strong> Access all PDF tools in one place without switching apps.
  </p>

  <p>
    <strong>User-Friendly Interface:</strong> Enjoy a clean layout with simple navigation.
  </p>

  <p>
    <strong>Fast Performance:</strong> Optimized processing for PDFs of any size.
  </p>

  <p>
    <strong>Secure:</strong> Your files are processed safely and never stored.
  </p>

  <p>
    <strong>Professional Output:</strong> Receive high-quality results that look great on any device.
  </p>

</div>


</div>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    paddingTop: '50px',
    fontFamily: 'Arial',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    marginTop: '30px',
  },
  button: {
    padding: '15px 25px',
    fontSize: '16px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
  },
};

export default Dashboard;
